import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import {
  formatDateWithDashes,
  sortedRatesTableData,
} from '../../../utils/helper';
import RequestQuoteModal from './requestQuoteModal';
interface Props {
  tableData: any;
  selectedRate: any;
  setSelectedRate: any;
  searchText: string;
  tableLoading: boolean;
  isPriceHidden: boolean;
  setShowPickupDeliveryScreen: any;
  setSelectedLegsInfo: any;
  selectedLegsInfo: any;
  existingLegs?: number;
  legNumber?: number;
  legIndex?: number;
}
const formatter = new Intl.NumberFormat('en-CA', {
  style: 'currency',
  currency: 'CAD',
});
const tooltipIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 7C0 3.1339 3.1339 0 7 0C10.8661 0 14 3.1339 14 7C14 10.8661 10.8661 14 7 14C3.1339 14 0 10.8661 0 7ZM7.7 4.2C7.7 4.01435 7.62625 3.8363 7.49497 3.70503C7.3637 3.57375 7.18565 3.5 7 3.5C6.81435 3.5 6.6363 3.57375 6.50503 3.70503C6.37375 3.8363 6.3 4.01435 6.3 4.2C6.3 4.38565 6.37375 4.5637 6.50503 4.69497C6.6363 4.82625 6.81435 4.9 7 4.9C7.18565 4.9 7.3637 4.82625 7.49497 4.69497C7.62625 4.5637 7.7 4.38565 7.7 4.2ZM7 10.5C7.18565 10.5 7.3637 10.4263 7.49497 10.295C7.62625 10.1637 7.7 9.98565 7.7 9.8V7C7.7 6.81435 7.62625 6.6363 7.49497 6.50503C7.3637 6.37375 7.18565 6.3 7 6.3C6.81435 6.3 6.6363 6.37375 6.50503 6.50503C6.37375 6.6363 6.3 6.81435 6.3 7V9.8C6.3 9.98565 6.37375 10.1637 6.50503 10.295C6.6363 10.4263 6.81435 10.5 7 10.5Z'
      fill='#251163'
    />
  </svg>
);
function RatesTable({
  tableData,
  setSelectedRate,
  selectedRate,
  searchText,
  tableLoading,
  isPriceHidden,
  setShowPickupDeliveryScreen,
  setSelectedLegsInfo,
  selectedLegsInfo,
  existingLegs,
  legNumber,
  legIndex,
}: Props) {
  // let service_tooltip = '';
  // let rate_tooltip = '';
  const [content, setContent] = useState<any>(null);
  const [rateArray, setRateArray] = useState<any>(null);

  const [openModal, setOpenModal] = useState(false);
  const [selectedKey, setSelectedKey] = useState<number>();
  const location = useLocation();
  const isAddLegs = location?.pathname === '/app/add-leg';
  const sortIcon = (
    <svg
      width='7'
      height='12'
      viewBox='0 0 7 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.7882 0.644001C3.75609 0.59959 3.71312 0.563278 3.663 0.538192C3.61287 0.513107 3.5571 0.5 3.50047 0.5C3.44385 0.5 3.38808 0.513107 3.33795 0.538192C3.28783 0.563278 3.24486 0.59959 3.21275 0.644001L0.0625043 4.97704C0.0260401 5.02701 0.00465731 5.08555 0.000677617 5.14629C-0.00330207 5.20703 0.0102749 5.26764 0.0399327 5.32155C0.0695906 5.37545 0.114195 5.42059 0.1689 5.45205C0.223606 5.48351 0.286319 5.50009 0.350227 5.5L6.65072 5.5C6.71448 5.49975 6.77696 5.48295 6.83145 5.45142C6.88593 5.41988 6.93036 5.3748 6.95995 5.32101C6.98954 5.26723 7.00317 5.20679 6.99938 5.14618C6.99559 5.08557 6.97452 5.02709 6.93844 4.97704L3.7882 0.644001Z'
        fill='#808080'
      />
      <path
        d='M3.2118 11.356C3.24391 11.4004 3.28688 11.4367 3.337 11.4618C3.38713 11.4869 3.4429 11.5 3.49953 11.5C3.55615 11.5 3.61192 11.4869 3.66205 11.4618C3.71217 11.4367 3.75514 11.4004 3.78725 11.356L6.9375 7.02296C6.97396 6.97299 6.99534 6.91445 6.99932 6.85371C7.0033 6.79297 6.98972 6.73236 6.96007 6.67845C6.93041 6.62455 6.8858 6.57941 6.8311 6.54795C6.77639 6.51649 6.71368 6.4999 6.64977 6.5H0.349279C0.285519 6.50025 0.223037 6.51705 0.168553 6.54858C0.114069 6.58012 0.069643 6.6252 0.0400537 6.67899C0.0104645 6.73277 -0.00316886 6.79321 0.000619828 6.85382C0.00440851 6.91443 0.0254759 6.97291 0.0615563 7.02296L3.2118 11.356Z'
        fill='#808080'
      />
    </svg>
  );

  const determine_carrier_name = (rate: any, key: number) => {
    let service_tooltip = '';
    let rate_tooltip = '';
    let routing = '';
    let origin = rate?.routing[0]?.origin;
    let firstDestination = rate?.routing[0]?.destination;
    let secondDestination = rate?.routing[1]?.destination;
    let carrierName = ``;
    let serviceName = ``;

    if (secondDestination) {
      routing = `<br/><span>${rate?.routing[0]?.origin_code} to ${rate?.routing[0]?.destination_code} to ${rate?.routing[1]?.destination_code}</span>`;
      carrierName = `${rate?.routing[0]?.carrier_name} / ${rate?.routing[1]?.carrier_name}`;
      serviceName = `${rate?.routing[0]?.service_name} / ${rate?.routing[1]?.service_name}`;
    } else {
      routing = `<br/><span>${origin} to ${firstDestination}</span>`;
      carrierName = `${rate?.routing[0]?.carrier_name}`;
      serviceName = `${rate?.routing[0]?.service_name}`;
    }

    const service_information =
      content?.carrier_service_info?.[rate?.routing[0]?.carrier_id];
    if (
      service_information &&
      service_information[rate?.routing[0]?.service_code]
    ) {
      service_tooltip = `${
        service_information[rate?.routing[0]?.service_code].description
      }\n\n${
        service_information[rate?.routing[0]?.service_code].service_days
      }\n${service_information[rate?.routing[0]?.service_code].exceptions}`;
    }
    let subtotal = formatter.format(
      parseFloat(rate?.rate?.total) - parseFloat(rate?.rate?.tax)
    );
    if (!isPriceHidden) {
      rate_tooltip = `Freight = $${
        rate?.rate?.freight
          ? parseFloat(rate?.rate?.freight).toFixed(2)
          : '0.00'
      } CAD\nSurcharge = $${
        rate?.rate?.surcharge
          ? parseFloat(rate?.rate?.surcharge).toFixed(2)
          : '0.00'
      } CAD\nSubtotal = ${subtotal} CAD\nTax = $${parseFloat(
        rate?.rate?.tax
      ).toFixed(2)} CAD\nTotal = $${parseFloat(rate?.rate?.total).toFixed(
        2
      )} CAD`;
    } else {
      rate_tooltip = `Freight = -\nSurcharge = -\nSubtotal = - CAD\nTax = -\nTotal = -`;
    }

    return {
      jsx: (
        <div className='d-flex gap-3'>
          <div
            className='me-2'
            style={{ visibility: service_tooltip ? 'visible' : 'hidden' }}
          >
            {tooltipIcon}
          </div>
          <div className=''>
            {carrierName}
            <br />
            <span className='mt-2'>
              {serviceName}
              {rate?.mode_code !== 'DIR' && (
                <div
                  className='col-sm-12 col-md-11'
                  dangerouslySetInnerHTML={{
                    __html: routing,
                  }}
                />
              )}
            </span>
          </div>
        </div>
      ),
      service_tooltip,
      rate_tooltip,
    };
  };

  const extractCarrierName = (rate: any) => {
    const service_information = content.carrier_service_info[rate?.carrier_id];
    const service_description =
      service_information &&
      service_information[rate.service_code]?.description;

    return `${rate.carrier_name} ${rate.service_name} ${service_description}`;
  };
  useEffect(() => {
    setContent(tableData?.content);
    setRateArray(tableData?.content?.rates);
    // setIsPriceHidden(tableData?.is_price_hide);
  }, [tableData]);
  const filteredRateArray = rateArray?.filter((item: any) =>
    extractCarrierName(item?.routing[0])
      ?.toLowerCase()
      ?.includes(searchText.toLowerCase())
  );
  const [sortColumn, setSortColumn] = useState('total');
  const [sortOrder, setSortOrder] = useState('asc');
  const [hoveredColumn, setHoveredColumn] = useState<any>(null);

  const handleSort = (column: any) => {
    if (sortColumn === column) {
      setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortColumn(column);
      setSortOrder('asc');
    }
  };

  function totalRate(total: any, tax: any) {
    let subTotal = parseFloat(total) - parseFloat(tax);
    return subTotal.toFixed(2);
  }

  function storeLegInfo(leg: any) {
    if (leg?.routing && leg.routing.length > 0) {
      let selectedLegs = leg.routing.map((route: any, index: number) => {
        return {
          leg: `${legNumber ? `L${legNumber}` : `A${index + 1}`}`,
          transit_days: leg?.transit_days,
          delivery_date: leg?.est_delivery_date,
          routing: route,
          ratesInfo: leg?.rate,
          rate_id: tableData?.content?.rate_id,
        };
      });
      setSelectedLegsInfo(selectedLegs);
    }
  }

  return (
    <>
      <div className='overflow-auto bg-white' style={{ maxHeight: '50rem' }}>
        <table
          id='main_rate_table'
          className='table sortable'
          data-page-length='25'
          onScroll={() => {
            // "table_scroll('main_rate_table_header')"
          }}
        >
          <thead
            id='main_rate_table_header'
            className='position-sticky top-0 ubbe-table-header'
          >
            <tr>
              <th
                className={`text-start align-middle cursor_pointer ubbe-table-heading-text`}
                style={{ width: '24%', paddingLeft: '48px' }}
                onClick={() => handleSort('carrier_name')}
                onMouseEnter={() => setHoveredColumn('carrier_name')}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                Carrier
                {sortColumn === 'carrier_name' && (
                  <span>
                    <i
                      className={`sort-icon bi bi-caret-${
                        sortOrder === 'asc' ? 'up' : 'down'
                      }-fill`}
                    ></i>
                  </span>
                )}
                {sortColumn !== 'carrier_name' &&
                  hoveredColumn === 'carrier_name' && (
                    <span
                      style={{
                        width: '20px',
                        display: 'inline-block',
                        marginLeft: '4px',
                      }}
                    >
                      {' '}
                      {sortIcon}{' '}
                    </span>
                  )}
              </th>
              <th
                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                style={{ width: '20%' }}
                onClick={() => handleSort('mode_name')}
                onMouseEnter={() => setHoveredColumn('mode_name')}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                Type
                <span style={{ width: '20px', display: 'inline-block' }}>
                  {sortColumn === 'mode_name' && (
                    <i
                      className={`sort-icon bi bi-caret-${
                        sortOrder === 'asc' ? 'up' : 'down'
                      }-fill`}
                    ></i>
                  )}
                  {sortColumn !== 'mode_name' &&
                    hoveredColumn === 'mode_name' && (
                      <span
                        style={{
                          width: '20px',
                          display: 'inline-block',
                          marginLeft: '4px',
                        }}
                      >
                        {' '}
                        {sortIcon}{' '}
                      </span>
                    )}
                </span>
              </th>
              <th
                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                style={{ width: '20%' }}
                onClick={() => handleSort('transit_days')}
                onMouseEnter={() => setHoveredColumn('transit_days')}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                Est. Business Days
                {sortColumn === 'transit_days' && (
                  <span style={{ width: '20px', display: 'inline-block' }}>
                    <i
                      className={`sort-icon bi bi-caret-${
                        sortOrder === 'asc' ? 'up' : 'down'
                      }-fill`}
                    ></i>
                  </span>
                )}
                {sortColumn !== 'transit_days' && (
                  <span style={{ width: '20px', display: 'inline-block' }}>
                    {hoveredColumn === 'transit_days' && (
                      <span
                        style={{
                          width: '20px',
                          display: 'inline-block',
                          marginLeft: '4px',
                        }}
                      >
                        {' '}
                        {sortIcon}{' '}
                      </span>
                    )}
                  </span>
                )}
              </th>
              <th
                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                style={{ width: '20%' }}
                onClick={() => handleSort('est_delivery_date')}
                onMouseEnter={() => setHoveredColumn('est_delivery_date')}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                Est. Delivery Date
                {sortColumn === 'est_delivery_date' && (
                  <span style={{ width: '20px', display: 'inline-block' }}>
                    <i
                      className={`sort-icon bi bi-caret-${
                        sortOrder === 'asc' ? 'up' : 'down'
                      }-fill`}
                    ></i>
                  </span>
                )}
                {sortColumn !== 'est_delivery_date' &&
                  hoveredColumn === 'est_delivery_date' && (
                    <span
                      style={{
                        width: '20px',
                        display: 'inline-block',
                        marginLeft: '4px',
                      }}
                    >
                      {' '}
                      {sortIcon}{' '}
                    </span>
                  )}
              </th>
              <th
                id='main_total_th'
                className='text-start align-middle cursor_pointer ubbe-table-heading-text'
                style={{ width: '25%' }}
                onClick={() => handleSort('total')}
                onMouseEnter={() => setHoveredColumn('total')}
                onMouseLeave={() => setHoveredColumn(null)}
              >
                Rate (Pre-Tax)
                {sortColumn === 'total' && (
                  <i
                    className={`sort-icon bi bi-caret-${
                      sortOrder === 'asc' ? 'up' : 'down'
                    }-fill`}
                  ></i>
                )}
                {sortColumn !== 'total' && hoveredColumn === 'total' && (
                  <span
                    style={{
                      width: '25px',
                      display: 'inline-block',
                      marginLeft: '4px',
                    }}
                  >
                    {' '}
                    {sortIcon}{' '}
                  </span>
                )}
              </th>
            </tr>
          </thead>
          <tbody
            id='rates-table-body bg-white'
            // className='legs'
          >
            {!tableLoading &&
            filteredRateArray &&
            sortedRatesTableData(filteredRateArray, sortColumn, sortOrder)
              .length > 0 ? (
              sortedRatesTableData(
                filteredRateArray,
                sortColumn,
                sortOrder
              ).map((item: any, key: number) => {
                const { jsx, service_tooltip, rate_tooltip } =
                  determine_carrier_name(item, key);
                //console.log(jsx);
                //console.log(rate_tooltip);
                //console.log(service_tooltip);
                return (
                  <tr
                    key={key}
                    className={`cursor_pointer ${
                      selectedKey ===
                        item?.routing[0]?.service_code +
                          item?.routing[0]?.carrier_id +
                          item?.rate?.sub_total ||
                      (isAddLegs
                        ? selectedRate &&
                          selectedRate?.routing?.carrier_id +
                            selectedRate?.routing?.service_code +
                            selectedRate?.ratesInfo?.sub_total ===
                            item?.routing[0]?.carrier_id +
                              item?.routing[0]?.service_code +
                              item?.rate?.sub_total
                        : selectedRate &&
                          JSON.stringify(selectedRate?.main) ===
                            JSON.stringify(item))
                        ? ' selected-rates-background'
                        : 'bg-white'
                    }`}
                    onClick={() => {
                      setSelectedRate({
                        ...selectedRate,
                        main: item,
                        delivery: undefined,
                        pickup: undefined,
                        transfer: undefined,
                      });
                      storeLegInfo(item);
                      setSelectedKey(
                        item?.routing[0]?.service_code +
                          item?.routing[0]?.carrier_id
                      );
                      if (
                        item?.pickup !== undefined &&
                        item?.delivery !== undefined &&
                        !isAddLegs
                      ) {
                        setShowPickupDeliveryScreen(true);
                      }
                    }}
                  >
                    <td
                      className={'py-3 align-middle text-start'}
                      style={{ width: '24%' }}
                      data-tooltip-id={`service-tooltip-${key}`}
                      data-tooltip-html={service_tooltip} // Use `data-tooltip-html` to render HTML
                    >
                      {jsx}
                      <Tooltip
                        id={`service-tooltip-${key}`}
                        className='tooltip-styles'
                        place='top-start'
                        style={{
                          zIndex: 1000,
                        }}
                      />
                    </td>
                    <td
                      className='py-3 text-start align-middle'
                      style={{ width: '15%' }}
                    >
                      {item?.mode_name}
                      {item?.transfer_rates &&
                        item?.transfer_rates.length > 0 && (
                          <>
                            <br />
                            +Mandatory Transfer
                          </>
                        )}
                      {item?.pickup !== undefined &&
                        item?.delivery !== undefined &&
                        !isAddLegs && (
                          <>
                            <br />
                            +Pickup & Delivery Extra
                          </>
                        )}
                    </td>
                    <td
                      className='py-3 text-start align-middle'
                      style={{ width: '16%' }}
                    >
                      {item?.transit_days === -1
                        ? 'N/A'
                        : item?.transit_days === 0
                        ? 'Same Day'
                        : item?.transit_days}
                    </td>
                    <td
                      className='py-3 text-start align-middle'
                      style={{ width: '16%' }}
                    >
                      {formatDateWithDashes(
                        new Date(item.est_delivery_date)
                      ) === '1-01-01'
                        ? 'N/A'
                        : formatDateWithDashes(
                            new Date(item.est_delivery_date)
                          )}
                    </td>
                    <td
                      className='py-3 text-start align-middle'
                      style={{ width: '19%' }}
                      data-tooltip-id={`rate-tooltip-${key}`}
                      data-tooltip-html={rate_tooltip}
                    >
                      <Tooltip
                        id={`rate-tooltip-${key}`}
                        className='tooltip-styles'
                        place='top-start'
                      />
                      {`$ ${
                        isPriceHidden
                          ? '-'
                          : totalRate(item?.rate?.total, item?.rate?.tax)
                      } CAD`}
                    </td>
                  </tr>
                );
              })
            ) : tableLoading ? (
              <tr className='text-start'>
                <td colSpan={9}>
                  <div className='spinner-border' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                  </div>
                </td>
              </tr>
            ) : searchText !== '' ? (
              <tr style={{ border: 'none' }}>
                {' '}
                <td
                  colSpan={9}
                  className='text-center global-text align-middle '
                  style={{
                    color: ' #979797                       ',
                    border: 'none',
                  }}
                >
                  Rates not found! Please try again.
                </td>
              </tr>
            ) : (
              <tr>
                <td className='bg-white' colSpan={5}>
                  <div className='d-flex align-items-center justify-content-center flex-column text-center p-4'>
                    <p>
                      Sorry, we are unable to gather gateway rates for your
                      request.
                      <br />
                      Please verify your origin and destination.
                    </p>
                    <button
                      className='mt-4 btn btn-ubbe-secondary d-flex align-items-center justify-content-center'
                      data-bs-toggle='modal'
                      data-bs-target='#bbe_quote_modal'
                      onClick={() => {
                        setOpenModal(true);
                      }}
                    >
                      <span className='me-1 mb_0'>
                        <svg
                          width='20'
                          height='20'
                          viewBox='0 0 20 20'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M15 0.5H5C2 0.5 0 2 0 5.5V12.5C0 16 2 17.5 5 17.5H15C18 17.5 20 16 20 12.5V5.5C20 2 18 0.5 15 0.5ZM15.47 6.59L12.34 9.09C11.68 9.62 10.84 9.88 10 9.88C9.16 9.88 8.31 9.62 7.66 9.09L4.53 6.59C4.21 6.33 4.16 5.85 4.41 5.53C4.67 5.21 5.14 5.15 5.46 5.41L8.59 7.91C9.35 8.52 10.64 8.52 11.4 7.91L14.53 5.41C14.85 5.15 15.33 5.2 15.58 5.53C15.84 5.85 15.79 6.33 15.47 6.59Z'
                            fill='#251163'
                            className='request-quote-icon-path'
                          />
                        </svg>
                      </span>
                      Request a Quote
                    </button>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {openModal && (
          <RequestQuoteModal legIndex={legIndex} setOpenModal={setOpenModal} />
        )}
      </div>
    </>
  );
}

export default RatesTable;
